import { Component, OnInit } from '@angular/core';
import { ShareDataService } from 'projects/shared/src/app/shared/share-data.service';

@Component({
  selector: 'app-tp-feedback-form',
  templateUrl: './tp-feedback-form.component.html',
  styleUrls: ['./tp-feedback-form.component.css']
})
export class TpFeedbackFormComponent implements OnInit {
  batchDetails: any;
  constructor(
    private sharedService: ShareDataService
  ) { }

  ngOnInit() {
    this.sharedService.getBatchDataForFeedbackForm().subscribe(batch => {
      this.batchDetails = batch;
    })
  }

}
